// Statut / disponibilité d'un quiz côté élève — logique CENTRALE extraite de
// QuizSelectionViewEleve pour être partagée avec la vue Île (IleEleve), afin
// d'avoir une seule source de vérité. Comportement strictement identique à
// l'existant (aucune régression) : bilans EvalNat + sessions QCM en ligne.
//
// e            : un item de `allQuizz` ({ source:'bilan'|'session', ... })
// verifierSiEleveARepondu : (e) => bool, fourni par EspaceEleve (gère l'id GAR)
export const getEtatQuiz = (e, verifierSiEleveARepondu) => {
  const isSession = e.source === 'session';
  const isCompleted = verifierSiEleveARepondu(e);

  // Quiz vidé de ses questions (session : suppression banque → CASCADE ; bilan :
  // éval sans questions) → injouable. `e.questions` est un tableau dans les deux cas
  // (bilans ET sessions au niveau de allQuizz).
  const estVide = !isCompleted && (e.questions || []).length === 0;

  // La date de passation est-elle arrivée ? (bilans pilotés par `date`,
  // sessions par `date_passation`).
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const evalDate = new Date(isSession ? e.date_passation : e.date);
  evalDate.setHours(0, 0, 0, 0);
  const isAvailable = !isNaN(evalDate.getTime()) && evalDate <= today;

  // Session clôturée par le prof (statut terminee) et non répondue → plus jouable
  // (le backend refuse le submit). Propre aux sessions ; les bilans n'ont pas de
  // clôture (pilotés par date).
  const estClose = isSession && e.statut === 'terminee' && !isCompleted;
  const verrouille = estVide || estClose; // injouable

  // État synthétique pour l'UI (île) : priorité terminé > verrouillé > bientôt > à faire.
  let etat;
  if (isCompleted) etat = 'termine';
  else if (verrouille) etat = 'verrouille';
  else if (!isAvailable) etat = 'bientot';
  else etat = 'afaire';

  return { isSession, isCompleted, estVide, isAvailable, estClose, verrouille, etat };
};

// Normalise la matière d'un quiz / thème vers la clé interne du switch
// ('maths' | 'francais' | null). Partagé par HomeEleve et IleEleve.
export const matiereKey = (m) =>
  (m === 'maths' || m === 'mathématiques') ? 'maths' : (m === 'français' ? 'francais' : null);
